import React from "react";
import {
  makeStyles,
  mergeClasses,
  tokens,
  Button,
  Text,
  Badge,
  Avatar,
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
  MenuDivider,
} from "@fluentui/react-components";
import {
  SignOut24Regular,
  Person24Regular,
  ShieldCheckmark24Regular,
  ChevronDown12Regular,
} from "@fluentui/react-icons";
import { useAuth, useIsMobile } from "../hooks";
import billietLogo from "../static/BILLIET-RGB-LOGO-BLAUW-1.png";

const useStyles = makeStyles({
  header: {
    position: "sticky",
    top: 0,
    zIndex: 50,
    backgroundColor: tokens.colorBrandBackground,
    paddingLeft: tokens.spacingHorizontalL,
    paddingRight: tokens.spacingHorizontalL,
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalM,
  },
  headerMobile: {
    paddingLeft: tokens.spacingHorizontalXS,
    paddingRight: tokens.spacingHorizontalXS,
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    gap: tokens.spacingHorizontalS,
    height: "25px",
    boxSizing: "content-box",
  },
  logoIcon: {
    width: "80px",
    height: "40px",
    objectFit: "contain",
    flexShrink: "0",
  },
  logoIconMobile: {
    width: "40px",
    height: "40px",
  },
  bar: {
    //backgroundColor: "#93A5BC",
    //borderRadius: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingLeft: tokens.spacingHorizontalL,
    paddingRight: tokens.spacingHorizontalL,
    //height: "80px",
    flexGrow: "1",
    minWidth: 0,
  },
  barMobile: {
    height: "25px",
    borderRadius: "12px",
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
  },
  barLeft: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalS,
  },
  logoText: {
    fontWeight: tokens.fontWeightBold,
    fontSize: tokens.fontSizeBase400,
    color: "#FFFFFF",
    whiteSpace: "nowrap",
  },
  logoTextMobile: {
    fontSize: tokens.fontSizeBase400,
  },
  barRight: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXS,
  },
  userMenuTrigger: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXS,
    color: "#FFFFFF",
    cursor: "pointer",
    background: "none",
    border: "none",
    padding: 0,
  },
  userMenuName: {
    color: "#FFFFFF",
  },
  userMenuNameMobile: {
    fontSize: tokens.fontSizeBase200,
  },
  menuItem: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalS,
  },
  badgeNoBorder: {
    borderTopColor: "transparent",
    borderBottomColor: "transparent",
    borderLeftColor: "transparent",
    borderRightColor: "transparent",
  },
});

export const Header: React.FC = () => {
  const { isAuthenticated, userName, userRole, login, logout } = useAuth();
  const isMobile = useIsMobile();
  const styles = useStyles();

  return (
    <header
      className={mergeClasses(styles.header, isMobile && styles.headerMobile)}
    >
      {/* Logo */}
      <img
        src={billietLogo}
        alt="Billiet logo"
        className={mergeClasses(
          styles.logoIcon,
          isMobile && styles.logoIconMobile,
        )}
      />

      {/* Rounded bar */}
      <div className={mergeClasses(styles.bar, isMobile && styles.barMobile)}>
        <div className={styles.barLeft}>
          <Text
            className={mergeClasses(
              styles.logoText,
              isMobile && styles.logoTextMobile,
            )}
          >
            iSales
          </Text>
        </div>

        <div className={styles.barRight}>
          {isAuthenticated ? (
            <Menu>
              <MenuTrigger disableButtonEnhancement>
                <button className={styles.userMenuTrigger}>
                  <Avatar
                    name={userName || "User"}
                    size={isMobile ? 24 : 28}
                    color="colorful"
                  />
                  <Text
                    className={mergeClasses(
                      styles.userMenuName,
                      isMobile && styles.userMenuNameMobile,
                    )}
                  >
                    {userName || "User"}
                  </Text>
                  <ChevronDown12Regular />
                </button>
              </MenuTrigger>
              <MenuPopover>
                <MenuList>
                  <MenuItem disabled>
                    <div className={styles.menuItem}>
                      <Badge
                        appearance="outline"
                        color="informative"
                        icon={<ShieldCheckmark24Regular />}
                        size="small"
                        className={styles.badgeNoBorder}
                      >
                        {userRole}
                      </Badge>
                    </div>
                  </MenuItem>
                  <MenuDivider />
                  <MenuItem icon={<SignOut24Regular />} onClick={logout}>
                    Sign out
                  </MenuItem>
                </MenuList>
              </MenuPopover>
            </Menu>
          ) : (
            <Button
              appearance="primary"
              icon={<Person24Regular />}
              onClick={login}
            >
              Sign In
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};
